import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { StartSessionAndGetSessionTokenResponseBody } from '../types/generated/sessionStart_post.response';
import { requestStart } from '../requests/requestStart';
import { useConfig } from './useConfig';
import { getAppParamValue } from '../../utils/getAppParamValue';
import { START_SESSION } from '../../constants';
import { useCfgParam } from '../../hooks/useCfgParam';

export const useStart = () => {
  const {
    state: { username, token },
    dispatch,
  } = useUserState();
  const [success, setSuccess] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const { getConfig } = useConfig();
  const mobileAppVersion: string | null = useCfgParam('mobileAppVersion');
  const { error, mutateAsync: start } = useMutation<
    StartSessionAndGetSessionTokenResponseBody,
    Error
  >({
    mutationFn: () => {
      setSuccess(false);
      setIsPending(true);
      return requestStart({ app: getAppParamValue(mobileAppVersion) });
    },
    onSuccess: async (response) => {
      if (response.sessionToken) {
        dispatch({ type: START_SESSION, payload: response });
        await getConfig({ sessionToken: response.sessionToken });
        setSuccess(true);
      }
      setIsPending(false);
    },
    onError: () => {
      setIsPending(false);
    },
    retry: 3,
  });

  return {
    isLoggedIn: !!(username && token),
    error,
    success,
    start,
    isPending,
  };
};
